import { ref, type Ref } from "vue"
import type { SnackbarMessage } from "vuetify/lib/components/VSnackbarQueue/VSnackbarQueue.mjs"

const queue: Ref<SnackbarMessage[]> = ref([])

export const useToast = () => {
    function add(message: SnackbarMessage) {
        queue.value.push(message)
    }

    return { queue, add }
}